import React from 'react';
import styled from 'styled-components';
import { Package, AlertCircle } from 'lucide-react';

const ProductsCard = styled.div`
  background: ${props => props.theme.colors.backgroundSecondary};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borders.radius.xl};
  padding: ${props => props.theme.spacing[6]};
  box-shadow: ${props => props.theme.shadows.lg};
`;

const ProductsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing[3]};
  margin-bottom: ${props => props.theme.spacing[4]};
`;

const ProductsTitle = styled.h2`
  font-size: ${props => props.theme.typography.fontSize['2xl']};
  font-weight: ${props => props.theme.typography.fontWeight.bold};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0;
`;

const ComingSoonBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing[12]} ${props => props.theme.spacing[6]};
  text-align: center;
  background: ${props => props.theme.colors.backgroundTertiary};
  border: 2px dashed ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borders.radius.lg};
`;

const ComingSoonIcon = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(251, 191, 36, 0.1);
  border-radius: ${props => props.theme.borders.radius.full};
  margin-bottom: ${props => props.theme.spacing[4]};
`;

const ComingSoonTitle = styled.h3`
  font-size: ${props => props.theme.typography.fontSize.xl};
  font-weight: ${props => props.theme.typography.fontWeight.bold};
  color: ${props => props.theme.colors.textPrimary};
  margin: 0 0 ${props => props.theme.spacing[2]} 0;
`;

const ComingSoonText = styled.p`
  font-size: ${props => props.theme.typography.fontSize.base};
  color: ${props => props.theme.colors.textSecondary};
  margin: 0;
  max-width: 500px;
`;

/**
 * Componente preparado para exibir produtos Braip
 * Atualmente mostra mensagem "Em breve" pois a API oficial
 * da Braip não disponibiliza endpoint público para listar produtos
 */
const BraipProducts: React.FC = () => {
  return (
    <ProductsCard>
      <ProductsHeader>
        <Package size={24} />
        <ProductsTitle>Produtos Braip</ProductsTitle>
      </ProductsHeader>

      <ComingSoonBox>
        <ComingSoonIcon>
          <AlertCircle size={40} color="#f59e0b" />
        </ComingSoonIcon>
        <ComingSoonTitle>Em Breve</ComingSoonTitle>
        <ComingSoonText>
          A listagem de produtos Braip estará disponível quando a plataforma
          disponibilizar um endpoint público em sua API. Por enquanto, você pode
          gerenciar seus produtos diretamente no painel da Braip.
        </ComingSoonText>
      </ComingSoonBox>
    </ProductsCard>
  );
};

export default BraipProducts;
